import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { formatDate } from '../Common/Utilities';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export function ChangeLogLookup(props) {
	const [data, setData] = useState([]);
	const [dataloaded, setDataloaded] = useState(false);
	const inProgressRef = useRef(false);

	const fetchInvoiceChangeLog = () => {
		const { rowData, changeLogData } = props.info;
		const invoiceDocumentId = rowData?.invoiceDocumentId || changeLogData?.invoiceDocumentId;

		if (!invoiceDocumentId) {
			props.info.inProgress(false);
			return;
		}

		httpGet(`/api/invoicedocument/invoicechangelog/${invoiceDocumentId}`)
			.then((response) => {
				const dataWithIds = response.data.map((row, index) => ({
					...row,
					id: index
				}));
				inProgressRef.current = false;
				setData(dataWithIds);
				setDataloaded(true);
				props.info.inProgress(false);
			})
			.catch((error) => {
				inProgressRef.current = false;
				props.info.inProgress(false);
				setDataloaded(true);
				toast.error('An error occurred while fetching the records');
			});
	};

	useEffect(() => {
		if (props.info.openDialog && !dataloaded && !inProgressRef.current) {
			inProgressRef.current = true;
			props.info.inProgress(true);
			fetchInvoiceChangeLog();
		}
	});

	const close_clickHandler = (event) => {
		setData([]);
		setDataloaded(false);
		inProgressRef.current = false;
		if (props.onClose) {
			props.onClose(event);
		}
	};

	const columns = 
		[
			{
				headerName: 'By',
				field: 'changedBy',
				flex: 1
			},
			{
				headerName: 'Date',
				field: 'changedDate',
				flex: 1,
				valueGetter: ({ value }) => value && new Date(value),
				valueFormatter: ({ value }) => value && formatDate(new Date(value))
			},
			{
				headerName: 'Field',
				field: 'fieldName',
				flex: 1
			},
			{
				headerName: 'Action',
				field: 'action',
				flex: 1
			},
			{
				headerName: 'New Value',
				field: 'newValue',
				flex: 1
			},
			{
				headerName: 'Old Value',
				field: 'oldValue',
				flex: 1
			}
		];


	return (
		<Dialog open={props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
			<DialogTitle>
				Change Log
			</DialogTitle>
			<DialogContent>
				<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
					<EnhancedDataGrid rows={data}
						disableColumnMenu
						pagination
						pageSize={10}
						height={580}
						columns={columns}
						options={{
							toolbar: false,
							sorting: false,
							draggable: false,
							pageSize: 10,
							pageSizeOptions: [10, 20, 30, 40, 50],
							maxBodyHeight: 350
						}}
						getRowId={(row) => row.id}
						disableSelectionOnClick
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Button autoFocus onClick={close_clickHandler} color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
